module.exports = __webpack_public_path__ + "static/assets/9bceb8f32fa621aa596acf546cab28e1.png";